export function appendFormData(
  formData: FormData,
  data: any,
  parentKey?: string
) {
  if (data === null || data === undefined) return;
  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      const key = parentKey ? `${parentKey}[${index}]` : `${index}`;
      appendFormData(formData, item, key);
    });
  } else if (
    typeof data === 'object' &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.entries(data).forEach(([key, value]) => {
      const formKey = parentKey ? `${parentKey}[${key}]` : key;
      appendFormData(formData, value, formKey);
    });
  } else {
    // primitive value, File, or Blob
    if (data !== undefined) {
      formData.append(parentKey!, data);
    }
  }
}
